import NoteStore from '../stores/NoteStore.js';
import SessionStore from '../stores/SessionStore.js'
import useStores from './useStores.js';

import Header from './Header.js';
import NoteButton from './NoteButton.js';

const images = require.context('../../public/images', true);

function PageNote() {
  useStores([SessionStore]);

  const imageFileName = NoteStore.getCurrentImage();
  const image = images(`./${imageFileName}`);
  const practice = SessionStore.getPractice();

  return (
    <>
      <Header />

      <div className="middle-image">
      <img src={image} alt='' />
      </div>

      <div className="bottom">
        {
          practice === 'name' &&
          <div class="buttons">
            <NoteButton note="C" />
            <NoteButton note="D" />
            <NoteButton note="E" />
            <NoteButton note="F" />
            <NoteButton note="G" />
          </div>
        }
        {
          practice === 'position' &&
          <div class="buttons">
            <NoteButton note="1" />
            <NoteButton note="2" />
            <NoteButton note="3" />
            <NoteButton note="4" />
            <NoteButton note="5" />
          </div>
        }
      </div>
    </>
  );
}

export default PageNote;
